import { IPromise, IQService } from 'angular';

import { Option } from '@contact/upgrade';

export function optToPromise<T>(opt: Option<T>, $q: IQService): IPromise<T> {
  return opt.map(value => $q.resolve(value)).getOrElseFunc(() => $q.reject());
}
